import PropTypes from "prop-types"
import React, { useState, useEffect } from "react"
import { Row, Col, Collapse } from "reactstrap"
import { Link, withRouter } from "react-router-dom"
import classname from "classnames"
import AuthUser from "components/AuthUser/AuthUser"
import { AllowedUsersAddTA } from "components/AuthUser/AllowedUserList"
//i18n
import { withTranslation } from "react-i18next"

import { connect } from "react-redux"

const Navbar = props => {
  const [dashboard, setdashboard] = useState(false)
  const [ui, setui] = useState(false)
  const [app, setapp] = useState(false)
  const [email, setemail] = useState(false)
  const [ecommerce, setecommerce] = useState(false)
  const [crypto, setcrypto] = useState(false)
  const [project, setproject] = useState(false)
  const [task, settask] = useState(false)
  const [contact, setcontact] = useState(false)
  const [blog, setBlog] = useState(false)
  const [component, setcomponent] = useState(false)
  const [form, setform] = useState(false)
  const [table, settable] = useState(false)
  const [chart, setchart] = useState(false)
  const [icon, seticon] = useState(false)
  const [map, setmap] = useState(false)
  const [extra, setextra] = useState(false)
  const [invoice, setinvoice] = useState(false)
  const [auth, setauth] = useState(false)
  const [utility, setutility] = useState(false)
  const [user, setUser] = useState(AuthUser())
  const [allowUser, setAllowUser] = useState(false)
  const allowedUsers = AllowedUsersAddTA

  useEffect(() => {
    //console.log(allowedUsers)
    allowedUsers.map((users, i) => {
      if (user.email === users) {
        setAllowUser(true)
      }
    })
  }, [user, allowedUsers])
  useEffect(() => {
    var matchingMenuItem = null
    var ul = document.getElementById("navigation")
    var items = ul.getElementsByTagName("a")
    for (var i = 0; i < items.length; ++i) {
      if (props.location.pathname === items[i].pathname) {
        matchingMenuItem = items[i]
        break
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem)
    }
  })
  function activateParentDropdown(item) {
    item.classList.add("active")
    const parent = item.parentElement
    if (parent) {
      parent.classList.add("active") // li
      const parent2 = parent.parentElement
      parent2.classList.add("active") // li
      const parent3 = parent2.parentElement
      if (parent3) {
        parent3.classList.add("active") // li
        const parent4 = parent3.parentElement
        if (parent4) {
          parent4.classList.add("active") // li
          const parent5 = parent4.parentElement
          if (parent5) {
            parent5.classList.add("active") // li
            const parent6 = parent5.parentElement
            if (parent6) {
              parent6.classList.add("active") // li
            }
          }
        }
      }
    }
    return false
  }

  return (
    <React.Fragment>
      <div className="topnav">
        <div className="container-fluid">
          <nav
            className="navbar navbar-light navbar-expand-lg topnav-menu"
            id="navigation"
          >
            <Collapse
              isOpen={props.leftMenu}
              className="navbar-collapse"
              id="topnav-menu-content"
            >
              <ul className="navbar-nav">
                <li className="nav-item dropdown">
                  <Link
                    className="nav-link dropdown-toggle arrow-none"
                    onClick={e => {
                      e.preventDefault()
                      setdashboard(!dashboard)
                    }}
                    to="dashboard"
                  >
                    <i className="bx bx-home-circle mr-1"></i>
                    {props.t("Dashboard")} {props.menuOpen}
                  </Link>
                </li>

                {user.roleID == 1 ? (
                  <li className="nav-item dropdown">
                    <Link
                      to="/#"
                      onClick={e => {
                        e.preventDefault()
                        setui(!ui)
                        setapp(false)
                      }}
                      className="nav-link dropdown-toggle arrow-none"
                    >
                      <i className="bx bx-tone mr-1"></i>
                      {props.t("Travel Agency")}{" "}
                      <div className="arrow-down"></div>
                    </Link>
                    <div className={classname("dropdown-menu ", { show: ui })}>
                      <div>
                        <Link
                          to="/configurations/list"
                          className="dropdown-item"
                        >
                          {props.t("List")}
                        </Link>
                        {allowUser ? (
                          <Link
                            to="/configurations/create"
                            className="dropdown-item"
                          >
                            {props.t("Add New")}
                          </Link>
                        ) : null}
                      </div>
                    </div>
                  </li>
                ) : null}
                {user.roleID == 1 ? (
                  <li className="nav-item dropdown">
                    <Link
                      to="/#"
                      onClick={e => {
                        e.preventDefault()
                        setapp(!app)
                        setui(false)
                      }}
                      className="nav-link dropdown-toggle arrow-none"
                    >
                      <i className="bx bx-detail mr-1"></i>
                      {props.t("More")} <div className="arrow-down"></div>
                    </Link>
                    <div className={classname("dropdown-menu ", { show: app })}>
                      <div>
                        <Link to="/othercharges" className="dropdown-item">
                          {props.t("Other Charges")}
                        </Link>
                        <Link
                          to="/payment-settlement"
                          className="dropdown-item"
                        >
                          {props.t("Payment Settlement")}
                        </Link>
                      </div>
                    </div>
                  </li>
                ) : null}
                {/* <li className="nav-item dropdown">
                  {user.roleID === 1 ? (
                    <Link
                      className="nav-link dropdown-toggle arrow-none"
                      to="/othercharges"
                    >
                      <i className=" mr"></i>
                      {props.t("Other Charges")}
                    </Link>
                  ) : null}
                </li>
                <li className="nav-item dropdown">
                  {user.roleID === 1 ? (
                    <Link
                      to="/payment-settlement"
                      className="nav-link dropdown-toggle arrow-none"
                    >
                      {props.t("Payment Settlement")}
                    </Link>
                  ) : null}
                </li> */}
              </ul>
            </Collapse>
          </nav>
        </div>
      </div>
    </React.Fragment>
  )
}

Navbar.propTypes = {
  leftMenu: PropTypes.any,
  location: PropTypes.any,
  menuOpen: PropTypes.any,
  t: PropTypes.any,
}

const mapStatetoProps = state => {
  const { leftMenu } = state.Layout
  return { leftMenu }
}

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(Navbar))
)
